const actionTypeIdentifier = 'E3B3B6F7-5C8A-4A7C-8F7A-2B9D9C3D6C1E';
export const getCountries = `GET-COUNTRIES-${actionTypeIdentifier}`;
export const getVendors = `GET-VENDORS-${actionTypeIdentifier}`;
export const getAccountNumbers = `GET-ACCOUNT-NUMBERS-${actionTypeIdentifier}`;
export const getInvoiceStatus = `GET-INVOICE-STATUS-${actionTypeIdentifier}`;
    